export default "__VITE_ASSET__DM2lbq6n__"